export default __webpack_public_path__ + "static/media/tiger_7_magicmint_normal_x_crayon_normal.11a92384.png";